const AscSortIcon = ({ height, width, color }) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" height={height} viewBox="0 -960 960 960" width={width} fill={color}>
      <path d="M444-96v-630L267-549l-51-51 264-264 264 264-51 51-177-177v630h-72Z" />
    </svg>
  );
};

export default AscSortIcon;
